import React from 'react';
import { DatePicker, Button, Radio, Input, message, Checkbox, ConfigProvider } from 'antd';
import Loading from '@/page/components/loading/loading';
import DocumentTitle from 'react-document-title';
import API from '@/api/api';
import moment from 'moment';
import UEditor from "@/page/components/ueditor/ueditor";
// import './add.less';
import zhCN from 'antd/es/locale/zh_CN';
var uploader = require('@/thirdTool/alioss/upload.js');
const { RangePicker } = DatePicker;

message.config({
    top: 200,
    duration: 2,
    maxCount: 3,
});

class CardAdd extends React.Component {

    constructor(props) {
        super(props)
    }

    state = {
        pageData: {
            id: '',
            name: '',
            couponImg: '',
            activateCouponImg: '',
            useExplain: '',
            actUseExplain: '',
            activeExplain: '',
            timeType: 0, // 0 绝对时间，1 相对时间
            startTime: '', // s
            endTime: '', // s
            receiveExpireTime: '',
            num: '',
            validateMode: '30',
            amount: '',
            comRange: [
                {
                    functionType: 40,
                    functionName: '美团外卖',
                    useCircleId: '',
                    useType: 0, // 0城市 1圈子
                    relationType: 0, // 0否 1 是
                    isSelect: false,
                },
                {
                    functionType: 41,
                    functionName: '美团打车',
                    useCircleId: '',
                    useType: 0, // 0城市 1圈子
                    relationType: 0, // 0否 1 是
                    isSelect: false,
                },
                {
                    functionType: 13,
                    functionName: '票友电影',
                    useCircleId: '',
                    useType: 0, // 0城市 1圈子
                    relationType: 0, // 0否 1 是
                    isSelect: false,
                },
                {
                    functionType: 14,
                    functionName: '机票',
                    useCircleId: '',
                    useType: 0, // 0城市 1圈子
                    relationType: 0, // 0否 1 是
                    isSelect: false,
                },
                {
                    functionType: 15,
                    functionName: '火车票',
                    useCircleId: '',
                    useType: 0, // 0城市 1圈子
                    relationType: 0, // 0否 1 是
                    isSelect: false,
                },
            ]
        },
        isLoading: true,
        hasClicked: false,
        defaultMoment: [],
        defaultValue: [],
        errorArr: new Map([
            ['amount', true],
            ['name', true],
            ['couponImg', true],
            ['activateCouponImg', true],
            ['useExplain', true],
            ['actUseExplain', true],
            ['startTime', true],
            ['receiveExpireTime', true],
            ['num', true],
        ]),
        templateId: ''
    }

    async getPictureInfo(url) { // 获取图片信息
        let result = await API.syncPic({ url: url });
        if (!result) return;
        if (result) {
            let picObj = {
                picture: url,
                width: result.ImageWidth.value,
                height: result.ImageHeight.value
            }
            return picObj;
        }
        else {
            message.error(result.msg);
        }
    };

    async getCouponDetail(templateId, callback) { // 获取券详情
        let result = await API.cardTemplateDetail({ templateId });
        if (!result) return;
        if (result.status == 1) {
            let pageData = result.data, defaultMoment = [];
            if (pageData.startTime) {
                defaultMoment.push(moment(pageData.startTime * 1000), moment(pageData.endTime * 1000));
            }
            pageData.comRange = JSON.parse(pageData.comRange);
            pageData.couponImg = JSON.parse(pageData.image)
            pageData.activateCouponImg = JSON.parse(pageData.actImage)
            pageData.amount = pageData.amount / 100;
            let defaultValue = pageData.comRange.map((item) => {
                if (item.isSelect) return item.functionName;
            }).filter(Boolean);
            this.setState({ defaultMoment, pageData, defaultValue, isLoading: false }, () => {
                callback();
                let { pageData } = this.state;
                let errorArr = new Map([
                    ['amount', false],
                    ['name', false],
                    ['couponImg', false],
                    ['activateCouponImg', false],
                    ['useExplain', false],
                    ['actUseExplain', false],
                    ['startTime', false],
                    ['receiveExpireTime', false],
                    ['num', false],
                ])
                this.setState({ errorArr })
                if (pageData.image) {
                    let chooseCouponImgDiv = document.getElementById('chooseCouponImg');
                    chooseCouponImgDiv.style.backgroundImage = 'url(' + pageData.couponImg.picture + ')';
                }
                if (pageData.actImage) {
                    let chooseActivateCouponImgDiv = document.getElementById('chooseActivateCouponImg');
                    chooseActivateCouponImgDiv.style.backgroundImage = 'url(' + pageData.activateCouponImg.picture + ')';
                }
                //编辑器类型处理
                if (pageData.useExplain) {
                    let ueditor = window.UE.getEditor('useExplain');
                    ueditor.ready(function () {
                        ueditor.setContent(pageData.useExplain);
                    });
                }
                if (pageData.actUseExplain) {
                    let ueditor2 = window.UE.getEditor('actUseExplain');
                    ueditor2.ready(function () {
                        ueditor2.setContent(pageData.actUseExplain);
                    });
                }

                if (pageData.activeExplain) {
                    let ueditor3 = window.UE.getEditor('activeExplain');
                    ueditor3.ready(function () {
                        ueditor3.setContent(pageData.activeExplain);
                    });
                }

            })
            return;
        }
        message.error(result.msg);
    };

    async edit(params) {
        const { templateId } = this.state;
        if (templateId) params.templateId = templateId;
        console.log('params', params)
        let result;
        result = params.templateId ?
            await API.cardTemplateEdit(params) :
            await API.cardTemplateAdd(params)
        if (!result) return;
        if (result.status == 1) {
            message.success(result.msg);
            this.goBack();
            return;
        }
        message.error(result.msg);
    };

    componentDidMount() {
        let { templateId } = this.props.location.state;
        if (templateId) {
            this.setState({ templateId }, () => {
                console.log('pageData', this.state.pageData)
                this.getCouponDetail(templateId, () => {
                    this.initUpload();
                });
            })
            return;
        }
        this.setState({ isLoading: false }, () => {
            this.initUpload();
        })
    }

    initUpload() { //初始化视频上传
        let self = this;
        let buttonList = [
            {
                buttonID: 'chooseCouponImg',
                picType: 'couponImg',
                extensions: 'jpg,png,bmp,jpeg',
            },
            {
                buttonID: 'chooseActivateCouponImg',
                picType: 'activateCouponImg',
                extensions: 'jpg,png,bmp,jpeg',
            },
        ]
        buttonList.map((item) => {
            setTimeout(() => {
                let buttonDiv = document.getElementById(item.buttonID);
                if (buttonDiv) {
                    uploader({
                        serverUrl: window.location.origin + '/promotion/oss/policy',
                        upload_button: item.buttonID,
                        multi: false,
                        extensions: 'jpg,png,bmp,jpeg',
                        added: function () {
                        },
                        success: function (file_url, file) {
                            self.getPictureInfo(file_url).then(obj => {
                                let { pageData, errorArr } = self.state;
                                if (item.picType == 'couponImg') {
                                    errorArr.set('couponImg', false);
                                    pageData.image = obj
                                }
                                if (item.picType == 'activateCouponImg') {
                                    pageData.actImage = obj
                                    errorArr.set('activateCouponImg', false);
                                }
                                self.setState({ pageData, errorArr })
                                buttonDiv.style.backgroundImage = 'url(' + obj.picture + ')';
                            });
                        },
                        error: function (msg) {
                            message.error(msg)
                        }
                    })
                }
            }, 100)
        })
    }

    handleUEditorChange = (type, content) => { //编辑器
        let { errorArr, pageData } = this.state;
        switch (type) {
            case 'useExplain':
                pageData.useExplain = content.trim();
                this.setState({ pageData });
                errorArr.set('useExplain', content.trim() == '' ? true : false);
                break;
            case 'actUseExplain':
                pageData.actUseExplain = content.trim();
                this.setState({ pageData });
                errorArr.set('actUseExplain', content.trim() == '' ? true : false);
                break;
            case 'activeExplain':
                pageData.activeExplain = content.trim();
                this.setState({ pageData });
                break;

        }
        this.setState({ errorArr });
    }

    timeTypeChange(timeType, e) {
        let { pageData } = this.state;
        pageData[timeType] = e.target.value;
        this.setState({ pageData });
    }

    useTypeChange(useType, index, e) {
        let { pageData } = this.state;
        pageData.comRange[index][useType] = e.target.value;
        this.setState({ pageData });
    }

    getQueryString(name) {//解析url
        const reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
        const urlObj = window.location;
        var r = urlObj.href.indexOf('#') > -1 ? urlObj.hash.split("?")[1].match(reg) : urlObj.search.substr(1).match(reg);
        if (r != null) return unescape(r[2]); return null;
    }


    dateChange(dates) { //时间范围变化函数
        let { errorArr, pageData } = this.state;
        if (dates.length == 0) {
            errorArr.set('startTime', true)
            errorArr.set('endTime', true)
            pageData.startTime = 0
            pageData.endTime = 0
            this.setState({ pageData, errorArr })
            return;
        }

        if (dates[0].valueOf()) {
            errorArr.set('startTime', false)
            pageData.startTime = dates[0].valueOf() / 1000;
        }
        if (dates[1].valueOf()) {
            errorArr.set('endTime', false)
            pageData.endTime = dates[1].valueOf() / 1000;
        }
        this.setState({ pageData, errorArr })
    }

    saveCoupon() {
        this.setState({ hasClicked: true }, () => {
            let { pageData, errorArr } = this.state;
            // 通用范围
            let comRangeTure = pageData.comRange.filter((item) => {
                return item.isSelect
            })
            if (comRangeTure.length == 0) {
                errorArr.set('comRange', true);
                this.setState({ errorArr });
                return
            }
            // 使用条件 指定圈子 公众圈ID
            let useCircleIdHave = true;
            pageData.comRange.map((item, index) => {
                if (item.useType == 1 && !item.useCircleId) {
                    useCircleIdHave = false
                    errorArr.set(`useCircleId${index}`, true);
                }
            })
            if (!useCircleIdHave) {
                this.setState({ errorArr });
                return
            }

            if (document.querySelectorAll('.formItemError')[0]) {
                let firstError = document.querySelectorAll('.formItemError')[0];
                window.scrollTo(0, firstError.offsetTop - 100);
                return;
            }
            pageData.amount = pageData.amount * 100
            pageData.comRange = JSON.stringify(pageData.comRange);
            pageData.couponImg = JSON.stringify(pageData.couponImg);
            pageData.activateCouponImg = JSON.stringify(pageData.activateCouponImg);
            this.edit(pageData)
        })

    }

    inputItemChange(type, e, index) {
        let value = e.target.value;
        let { errorArr, pageData } = this.state;
        switch (type) {
            case 'name':
                errorArr.set('name', value.trim() == '' ? true : false);
                pageData.name = value;
                this.setState({ pageData })
                break;
            case 'receiveExpireTime':
                errorArr.set('receiveExpireTime', value.trim() == '' ? true : false);
                pageData.receiveExpireTime = value;
                this.setState({ pageData })
                break;
            case 'num':
                errorArr.set('num', value.trim() == '' ? true : false);
                pageData.num = value;
                this.setState({ pageData })
                break;
            case 'amount':
                errorArr.set('amount', value.trim() == '' ? true : false);
                pageData.amount = value;
                this.setState({ pageData })
                break;
            case 'useCircleId':
                errorArr.set(`useCircleId${index}`, value.trim() == '' ? true : false);
                pageData.comRange[index].useCircleId = value;
                this.setState({ objectIds: value })
                break;
        }
        this.setState({ errorArr })
    }

    inputItemChangeChild(type, index, e) {
        let value = e.target.value;
        let { errorArr, pageData } = this.state;
        errorArr.set(`${type}${index}`, value.trim() == '' ? true : false);
        pageData.comRange[index][type] = value;
        this.setState({ objectIds: value })
        this.setState({ errorArr })
    }

    goBack() {
        this.props.history.go(-2)
    }

    generalScopeChange(checkedValues) {
        let { pageData, errorArr } = this.state;
        if (checkedValues.length == 0) {
            errorArr.set('comRange', true);
            pageData.comRange.map((i, index) => {
                pageData.comRange[index].isSelect = false;
            })
        } else {
            errorArr.set('comRange', false);
            pageData.comRange.map((i, index) => {
                pageData.comRange[index].isSelect = false;
                checkedValues.map((item) => {
                    if (item == i.functionName) {
                        pageData.comRange[index].isSelect = true;
                    }
                })
            })

        }
        this.setState({ pageData, errorArr })
    }

    conditionChange(type, index, e) {
        let { pageData } = this.state;
        pageData.comRange[index][type] = e.target.checked;
        this.setState({ pageData })
    }

    render() {
        const {
            hasClicked,
            errorArr,
            defaultMoment,
            pageData,
            defaultValue,
            isLoading,
        } = this.state;
        if (isLoading) return <Loading />;
        const {
            id,
            name,
            useExplain,
            actUseExplain,
            activeExplain,
            timeType, // 0 绝对时间，1 相对时间
            receiveExpireTime,
            num,
            comRange,
            amount,
        } = pageData;
        let plainOptions = comRange.map((item) => {
            return item.functionName
        })
        return (
            <DocumentTitle title="消费卡">
                <ConfigProvider locale={zhCN}>
                    <div className="couponsAdd">
                        {/* <Button onClick={this.goBack.bind(this)}>返回</Button> */}
                        <div className="inputItem">
                            <span className="inputTitle">卡名称</span>
                            <Input className="inputBlock" value={name} placeholder="请输入卡名称" onChange={this.inputItemChange.bind(this, 'name')}></Input>
                            {hasClicked && errorArr.get('name') && <span className="formItemError">请输入卡名称</span>}
                        </div>
                        <div className="inputItem">
                            <span className="inputTitle">卡面值(元)</span>
                            <Input className="inputBlock" value={amount} placeholder="请输入卡面值" onChange={this.inputItemChange.bind(this, 'amount')}></Input>
                            {hasClicked && errorArr.get('amount') && <span className="formItemError">请输入卡面值</span>}
                        </div>
                        <div className="inputItem">
                            <span className="inputTitle">激活前卡图片</span>
                            <div id="chooseCouponImg" className="chooseCouponImg"></div>
                            {hasClicked && errorArr.get('couponImg') && <span className="formItemError">请上传激活前卡图片</span>}
                        </div>
                        <div className="inputItem align-flex-start">
                            <span className="inputTitle">激活前使用说明</span>
                            <div className="editorPane">
                                <UEditor id='useExplain' content={useExplain} onChange={this.handleUEditorChange.bind(this, 'useExplain')} />
                                {hasClicked && errorArr.get('useExplain') && <span className="editorItemError">请填写激活前使用说明</span>}
                            </div>
                        </div>
                        <div className="inputItem">
                            <span className="inputTitle">激活后卡图片</span>
                            <div id="chooseActivateCouponImg" className="chooseActivateCouponImg"></div>
                            {hasClicked && errorArr.get('activateCouponImg') && <span className="formItemError">请上传激活后卡图片</span>}
                        </div>
                        <div className="inputItem align-flex-start">
                            <span className="inputTitle">激活后使用说明</span>
                            <div className="editorPane">
                                <UEditor id='actUseExplain' content={actUseExplain} onChange={this.handleUEditorChange.bind(this, 'actUseExplain')} />
                                {hasClicked && errorArr.get('actUseExplain') && <span className="editorItemError">请填写激活后使用说明</span>}
                            </div>
                        </div>
                        <div className="inputItem align-flex-start">
                            <span className="inputTitle">激活条件</span>
                            <div className="editorPane">
                                <UEditor id='activeExplain' content={activeExplain} onChange={this.handleUEditorChange.bind(this, 'activeExplain')} />
                            </div>
                        </div>
                        <div className="inputItem">
                            <span className="inputTitle">有效期</span>
                            <Radio.Group onChange={this.timeTypeChange.bind(this, 'timeType')} value={timeType}>
                                <Radio value={0}>绝对时间</Radio>
                                <Radio value={1}>相对时间</Radio>
                            </Radio.Group>
                        </div>
                        {
                            timeType == 0 &&
                            <div className="inputItem">
                                <span className="inputTitle">开始时间-结束时间</span>
                                <RangePicker className="datePicker" defaultValue={defaultMoment} width={400} format="YYYY-MM-DD HH:mm:ss" showTime={{ defaultValue: [moment('00:00:00', 'HH:mm:ss'), moment('11:59:59', 'HH:mm:ss')] }} onChange={this.dateChange.bind(this)} />
                                {hasClicked && (errorArr.get('startTime') || errorArr.get('endTime')) && <span className="formItemError">请选择券使用时间</span>}
                            </div>
                        }
                        {
                            timeType == 1 &&
                            <div className="inputItem">
                                <span className="inputTitle">过期时间(天)</span>
                                <Input className="inputBlock" value={receiveExpireTime} placeholder="请输入整数天" onChange={this.inputItemChange.bind(this, 'receiveExpireTime')}></Input>
                                {hasClicked && errorArr.get('receiveExpireTime') && <span className="formItemError">请输入过期时间</span>}
                            </div>
                        }
                        <div className="inputItem">
                            <span className="inputTitle">卡数量</span>
                            <Input className="inputBlock" value={num} placeholder="请输入整数" onChange={this.inputItemChange.bind(this, 'num')}></Input>
                            {hasClicked && errorArr.get('num') && <span className="formItemError">请输入卡数量</span>}
                        </div>
                        <div className="inputItem">
                            <span className="inputTitle">通用范围</span>
                            {
                                ((id && defaultValue.length > 0) || !id) &&
                                <Checkbox.Group options={plainOptions} defaultValue={defaultValue} onChange={this.generalScopeChange.bind(this)} />
                            }
                            {hasClicked && errorArr.get('comRange') && <span className="formItemError">请选择通用范围</span>}
                        </div>
                        {/* {
                            comRange && comRange.length > 0 &&
                            <div className="inputItem">
                                <span className="inputTitle">通用范围</span>
                            </div>
                        } */}
                        {
                            comRange && comRange.length > 0 &&
                            comRange.map((item, index) => {
                                if (item.isSelect) {
                                    return (
                                        <div className='conditionModel' key={index}>
                                            <div className="inputItem">
                                                <span className="inputTitle">{item.functionName}使用条件</span>
                                                <Radio.Group onChange={this.useTypeChange.bind(this, 'useType', index)} value={item.useType}>
                                                    <Radio value={0}>城市圈子</Radio>
                                                    <Radio value={1}>指定圈子</Radio>
                                                </Radio.Group>
                                                {
                                                    item.useType == 1 &&
                                                    <div>
                                                        <span className='useCircleId'>公众圈ID</span>
                                                        <Input className="inputBlock" value={item.useCircleId} placeholder="请输入" onChange={this.inputItemChangeChild.bind(this, 'useCircleId', index)}></Input>
                                                        {hasClicked && errorArr.get(`useCircleId${index}`) && <span className="formItemError">请输入公众圈ID</span>}
                                                    </div>
                                                }
                                            </div>
                                            <div className="relationType">
                                                <Checkbox checked={item.relationType} onChange={this.conditionChange.bind(this, 'relationType', index)}>业务关联</Checkbox>
                                            </div>
                                        </div>
                                    )
                                }
                            })
                        }
                        <Button onClick={this.saveCoupon.bind(this)}>立即创建</Button>
                    </div>
                </ConfigProvider>
            </DocumentTitle>
        )
    }
}
export default CardAdd;
